import { useEffect, useRef, useState } from "react";
import LeaguePopup from "./popups/LeaguePopup";
import PracticeGamePopup from "./popups/PracticeGamePopup";
import useTranslation from "next-translate/useTranslation";
import ChatWindow from "../../components/ChatWindow";

import styles from "./styles/ChatWindow.module.css";
import GameInfo from "./GameInfo";
import ReviewPreview from "./ReviewPreview";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { StatusTypes } from "@chesshotel/constants";

enum Tabs {
  MOVE,
  CHAT,
  REVIEW,
}

export default function GamePlayTemplate({
  isDesktop,
  boardSize,
  leagueScoreResult,
  resultId,
  resultTypeId,
  gameEnded,
  leaguePlay,
  playingWhite,
  opponentUsername,
  chatMessages,
  chatOpened,
  setChatOpened,
  showChatWindow,
  handleShowChatWindow,
  displayGame = null,
  gameId,
  Moves,
  GameChat,
  UserPlayer,
  OpponentPlayer,
  GameAd,
  GameButtons,
  children,
  newPlayer,
}) {
  const [selectedTab, setSelectedTab] = useState(Tabs.MOVE);
  const [showLeaguePopup, setLeaguePopup] = useState(false);
  const [showEndGamePopup, setEndGamePopup] = useState(false);

  const chatLength = useRef(chatMessages.length);

  useEffect(() => {
    if (isDesktop) {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    if (gameId && gameEnded) {
      setSelectedTab(Tabs.MOVE);
      if (leaguePlay && resultTypeId != StatusTypes.ABORT) {
        setLeaguePopup(true);
      } else if (!isDesktop) {
        setEndGamePopup(true);
      }
    }
  }, [gameEnded, gameId]);

  useEffect(() => {
    if (chatMessages.length != chatLength.current) {
      setSelectedTab(Tabs.CHAT);
      chatLength.current = chatMessages.length;
    }
  }, [chatMessages]);

  const { t } = useTranslation("common");

  function renderTab() {
    if (selectedTab == Tabs.MOVE) {
      return Moves;
    }

    if (selectedTab == Tabs.CHAT) {
      return GameChat;
    }

    if (selectedTab == Tabs.REVIEW) {
      return <ReviewPreview />;
    }
  }

  return (
    <>
      <div className="relative flex flex-col py-2 md:flex-row-reverse md:justify-center md:py-5 lg:flex lg:justify-center">
        {chatOpened && (
          <ChatWindow
            title={t("Chat with %player", { player: opponentUsername })}
            onClose={() => handleShowChatWindow(false)}
            onAnimationEnd={(e) => {
              if (e.animationName === styles.slideOutHam) {
                setChatOpened(false);
              }
            }}
            customClass={
              showChatWindow ? styles.slideInHam : styles.slideOutHam
            }
          >
            {GameChat}
          </ChatWindow>
        )}
        <div
          className={
            "flex flex-row w-full md:flex-col space-x-2 md:space-x-0 md:mx-2 md:space-y-3 md:w-80 lg:w-[300px] "
          }
        >
          {(!newPlayer || isDesktop) && (
            <div className="flex flex-col w-full md:w-auto  md:rounded-md  md:border-b-[3px]">
              {OpponentPlayer}
            </div>
          )}
          <div
            className={`flex-col hidden text-sm bg-white border rounded-md md:flex md:border-b-[3px] `}
            style={isDesktop ? { height: boardSize - 202 } : {}}
          >
            <div className="flex font-semibold ">
              <div
                onClick={() => setSelectedTab(Tabs.MOVE)}
                className={`flex items-center    pl-4 space-x-1 py-3 w-full
              hover:${
                !displayGame ? "opacity-70 cursor-pointer" : "opacity-100"
              } 
               ${
                 selectedTab == Tabs.MOVE
                   ? `border-b-4 border-b-altblue-300`
                   : "border-b-4 border-b-gray-200 text-altgray-600"
               }`}
              >
                <div>{t("Moves")}</div>
              </div>
              {!displayGame && (
                <div
                  onClick={() => setSelectedTab(Tabs.CHAT)}
                  className={`flex items-center   pl-4 space-x-1 py-3 w-full cursor-pointer hover:opacity-70 ${
                    selectedTab == Tabs.CHAT
                      ? `border-b-4 border-b-altblue-300 `
                      : "border-b-4 border-b-gray-200 text-altgray-600"
                  }`}
                >
                  <div>{t("Chat")}</div>
                </div>
              )}
            </div>
            <div className="flex flex-col flex-1 h-auto overflow-auto">
              {renderTab()}
            </div>
            <div className="justify-center hidden py-3 border-t rounded-b-md md:flex">
              {GameButtons}
            </div>
          </div>

          {(!newPlayer || isDesktop) && (
            <div className="flex flex-col w-full md:w-auto md:rounded-md md:border-b-[3px]">
              {UserPlayer}
            </div>
          )}
        </div>

        {newPlayer && !isDesktop && OpponentPlayer}
        <div className="border-y border-altgray-200 md:border-0">
          <span className="flex flex-col md:pr-3">{children}</span>
        </div>

        {newPlayer && !isDesktop && UserPlayer}
        {displayGame && <GameInfo />}
        {GameAd}

        <div className="flex justify-center py-4 md:hidden">{GameButtons}</div>
        {leagueScoreResult && showLeaguePopup && (
          <LeaguePopup
            onClose={() => setLeaguePopup(false)}
            result={resultId}
            status={resultTypeId}
            leagueScoreResult={leagueScoreResult}
          />
        )}
        {gameEnded && showEndGamePopup && (
          <PracticeGamePopup
            result={resultId}
            status={resultTypeId}
            playingWhite={playingWhite}
            opponentName={opponentUsername}
            onClose={() => setEndGamePopup(false)}
          />
        )}

        {/* {!isDesktop && GameAd} */}
      </div>
    </>
  );
}
